export default {
  CPQ: {
    "button.createQuote": "Create quote",
    "dialog.confirm.genericDelete.subtitle":
      "¿Realmente desea eliminar este elemento?",
    "opportunity.title": "Oportunidad",
    "opportunity.heading": "Oportunidad {{name}} {{id}}",
    "cart.title": "Carrito",
    "button.addQuote": "Agregar cotización",
    "button.addLineItem": "Nuevo elemento de línea",
    "dialog.addLineItem.title": "Nuevo elemento de línea",
    "button.presets": "Preajustes",
    "button.upload": "Carga",
    "button.archive": "Archivar",
    "button.createOpportunity": "Crear oportunidades",
    "button.cancel": "Cancelar",
    "button.save": "De acuerdo",
    "button.reset": "Reanudar",
    "button.confirm": "De acuerdo",
    "button.goToCatalog": "Ir al catálogo",
    "button.inventoryDocumentation": "Inventario de documentación",
    "button.download": "Descargar",
    "button.start": "Empezar",
    "button.logout": "Cerrar sesión",
    "button.addCustomProduct": "Producto personalizado",
    "button.addProduct": "Producto",
    "button.addFilter": "Añadir filtro",
    "button.delete": "Borrar",
    "select.language": "Idioma",
    "dialog.createOpportunity.subtitle": "Crea una nueva oportunidad",
    "dialog.updateOpportunity.title": "Oportunidad de edición",
    "dialog.updateOpportunity.subtitle": "Editar una oportunidad existente",
    "button.footer.backToOverview": "Volver al sumario",
    "button.footer.saveAndExit": "Guardar y salir",
    "footer.status.title": "Status",
    "button.footer.setStatusManually": "Set status manually",
    "button.footer.generateDocument": "Generar documentación",
    "button.preview": "Preview",
    "button.footer.backToConfiguration": "Volver a la configuración",
    "button.addConfigurableProduct": "Agregar producto configurado",
    "buttons.addConfigurationToItemGroupsButtonSelect.label":
      "Agregar a la cotización",
    "button.unarchiveOpportunity": "Restaurar",
    "button.archiveOpportunity": "Archivo",
    "button.addItemGroup": "Nuevo grupo",
    "button.updateItemGroup": "Editar",
    "dialog.createCustomer.title": "Create customer",
    "dialog.createCustomer.subtitle": "Create a new customer",
    "dialog.createCompany.title": "Create company",
    "dialog.createCompany.subtitle": "Create a new company",
    "dialog.addLineItem.input.label.lineItemName": "Line item name",
    "dialog.createOpportunity.input.label.opportunityName": "Nombre",
    "dialog.createOpportunity.input.label.customer": "Cliente",
    "dialog.createOpportunity.input.label.zipCode": "Código postal",
    "dialog.createOpportunity.input.label.city": "Ciudad",
    "dialog.createOpportunity.input.label.description": "Descripción",
    "dialog.createOpportunity.title": "Nueva oportunidad",
    "dialog.createOpportunity.input.validFrom.label": "Válido desde",
    "dialog.createOpportunity.input.validTo.label": "Válido hasta",
    "dialog.configuratorMode.title": "Crear nuevo presupuesto",
    "dialog.configuratorMode.option.configurator.title": "Configuración",
    "dialog.configuratorMode.option.configurator.description":
      "Configuración general del sistema",
    "dialog.configuratorMode.option.expressMode.title": "Express Mode",
    "dialog.configuratorMode.option.expressMode.description":
      "Single item order",
    "dialog.configuratorMode.description": "Choose your preferred mode",
    "dialog.confirm.unarchiveQuote.title": "Restore quote",
    "dialog.confirm.unarchiveQuote.description":
      "Do you really want to restore this quote?",
    "dialog.confirm.archiveQuote.title": "Archive quote",
    "dialog.confirm.archiveQuote.description":
      "Do you really want to archive this quote?",
    "dialog.confirm.unarchiveOpportunity.title": "Restore opportunity",
    "dialog.confirm.unarchiveOpportunity.description":
      "Do you really want to restore this opportunity?",
    "dialog.confirm.archiveOpportunity.title": "Archive opportunity",
    "dialog.confirm.archiveOpportunity.description":
      "Do you really want to archive this opportunity?",
    "dialog.confirm.setOptional.title": "Set optional",
    "dialog.confirm.unsetOptional.title": "Unset optional",
    "dialog.confirm.setOptional.subtitle":
      "Do you really want to set this item as optional?",
    "dialog.confirm.unsetOptional.subtitle":
      "Do you really want to unset this item as optional?",
    "dialog.confirm.genericDelete.title": "Eliminar",
    "dialog.addProducts.title.addProduct": "Seleccionar productos",
    "dialog.addItemGroup.title": "New group",
    "dialog.addItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateItemGroup.title": "Edit group",
    "dialog.updateItemGroup.input.label.itemGroupName": "Group name",
    "dialog.updateLineItem.title": "Edit line item",
    "dialog.updateLineItem.input.label.itemGroupName": "Line item name",
    "dialog.updateDefault.title": "Editar",
    "dialog.updateDefault.input.label.name": "Nombre",
    "dialog.addCustomProduct.title": "Add custom product",
    "dialog.addCustomProduct.identifier": "Identifier",
    "dialog.addCustomProduct.partId": "Article number",
    "dialog.addCustomProduct.name": "Name",
    "dialog.addCustomProduct.description": "Description",
    "dialog.addCustomProduct.customer": "Customer",
    "dialog.addCustomProduct.productTypeId": "Descripción del producto",
    "dialog.addCustomProduct.productStateId": "Product State",
    "dialog.addCustomProduct.isShared": "Shared product",
    "dialog.addCustomProduct.isActive": "Active",
    "breadcrumb.opportunities": "Opportunities",
    "breadcrumb.quotes": "Quotes",
    "breadcrumb.itemGroups": "Item Groups",
    "breadcrumb.archive": "Archive",
    "breadcrumb.configurator": "Configurator",
    "breadcrumb.expressMode": "Express mode",
    "breadcrumb.lineItems": "Line item",
    "breadcrumb.overview": "Overview",
    "breadcrumb.catalog": "Catalog",
    "breadcrumb.salesQuotationView": "Sales quotation view",
    "breadcrumb.summaryView": "Summary view",
    "breadcrumb.ManagementView": "Management view",
    "breadcrumb.quoteInfo": "Quote info",
    "breadcrumb.texts": "Texts",
    "breadcrumb.documentGeneration": "Generación de documentos",
    "header.opportunity": "Opportunity",
    "header.opportunities": "Opportunities",
    "header.quoteDetails": "Quote",
    "header.itemGroupDetails": "Item Group",
    "header.archive": "Archive",
    "header.configurator": "Configurador",
    "header.expressMode": "Express mode",
    "header.lineItemDetails": "Line item",
    "header.presets": "Presets",
    "dropZone.label": "Drag & drop or browse",
    "dropZone.isDragActive.label": "Drop here",
    "fileUpload.label": "Stock images",
    "filters.input.label.identifier": "Nombre",
    "filters.input.label.zipCode": "Código postal",
    "filters.input.label.city": "Ciudad",
    "filters.input.label.customer": "Cliente",
    "filters.input.label.status": "Status",
    "filters.input.label.search": "Buscar",
    "quote.property.label.uniqueNumberString": "Quote number",
    "quote.property.label.name": "Nombre",
    "quote.property.label.description": "Descripción",
    "quote.property.label.region": "Estado",
    "quote.property.label.revision": "Número de revisión",
    "quote.property.label.createdBy": "Creado por",
    "quote.property.label.customer": "Cliente",
    "quote.property.label.lastUpdatedOn": "Última actualización el",
    "quote.property.label.lastUpdatedBy": "Actualizado por",
    "quote.property.label.status": "Status",
    "accordion.itemGroup.title": "Group",
    "itemGroup.name": "Group Name",
    "table.actions.deleteRow": "Borrar",
    "table.lineItems.header.articleNumber": "Artículo",
    "table.lineItems.header.partId": "GPS ID",
    "table.lineItems.header.name": "Nombre",
    "table.lineItems.header.identifier": "ID",
    "table.lineItems.header.productIdentifier": "ID del producto",
    "table.lineItems.header.description": "Descripción",
    "table.lineItems.header.quantity": "Cantidad",
    "table.lineItems.header.actions": "Acciones",
    "table.lineItems.header.optional": "Opcional",
    "table.lineItems.header.company": "Empresa",
    "table.lineItems.actions.cloneRow": "Clon",
    "table.lineItems.actions.deleteRow": "Borrar",
    "table.lineItems.actions.showBOM": "Show BOM",
    "table.lineItems.actions.showSummary": "Show Summary",
    "catalog.productTable.header.favorit": "Favorit",
    "catalog.productTable.header.preview": "Preview",
    "catalog.productTable.header.articleNumber": "Article number",
    "catalog.productTable.header.name": "Name",
    "catalog.productTable.header.description": "Description",
    "catalog.productTable.header.cost": "cost",
    "catalog.productTable.header.totalCost": "Total cost",
    "catalog.productTable.header.listPrice": "List price",
    "catalog.productTable.header.actions": "Quantity",
    "catalog.productTable.header.createdByName": "Created by",
    "catalog.productTable.header.createdOn": "Created On",
    "catalog.productTable.header.lastUpdatedOn": "Last updated on",
    "catalog.productTable.header.lastUpdatedByName": "Last updated by",
    "catalog.productTable.buttons.addProductToGroup": "Add",
    "catalog.productTable.buttons.addAllProductsToGroup": "Add all",
    "catalog.productTable.menu.addLineItemToNewGroup": "Create new group",
    "catalog.buttons.showLineItems": "Show line items",
    "catalog.buttons.columnsSelection": "Columns",
    "buttons.toggleSideView.label": "Sideview",
    "product.types.tooltip.Configurable": "Configurable",
    "product.types.tooltip.NonConfigurable": "Non configurable",
    "product.types.tooltip.PreConfigured": "Preconfigured",
    "product.types.tooltip.configurationStatus.toConfigure": "To be configured",
    "product.types.tooltip.configurationStatus.complete":
      "Configuration is complete",
    "product.types.tooltip.configurationStatus.incomplete":
      "Configuration is incomplete",
    "product.status.text.toConfigure": "Configure",
    "product.status.text.complete": "Configured",
    "product.status.text.incomplete": "Edit",
    "productsTable.tree.filter": "Filter",
    "productsTable.tree.categoriesToggleText": "Categories",
    "relatedProducts.title": "Related products",
    "relatedProducts.noProducts": "No products",
    "alternativeProducts.title": "Alternative products",
    "table.itemGroups.title": "Project",
    "table.itemGroups.header.rank": "Rank",
    "table.itemGroups.header.moveRow": "Move row",
    "table.itemGroups.header.name": "Name",
    "table.itemGroups.header.description": "Description",
    "table.itemGroups.header.partId": "Part ID",
    "table.itemGroups.header.managingEntity": "Managing entity (ME)",
    "table.itemGroups.header.priceList": "Price list",
    "table.itemGroups.header.supportingEntity": "Supporting entity (SE)",
    "table.itemGroups.header.qty": "Quantity",
    "table.itemGroups.header.itemCost": "Item cost",
    "table.itemGroups.header.costListPricing": "Cost+/List-pricing",
    "table.itemGroups.header.markup": "Markup",
    "table.itemGroups.header.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.header.itemList": "Item list",
    "table.itemGroups.header.totalList": "Total List",
    "table.itemGroups.header.discount": "Discount",
    "table.itemGroups.header.discount2": "Discount 2",
    "table.itemGroups.header.discount3": "Discount 3",
    "table.itemGroups.header.discount4": "Discount 4",
    "table.itemGroups.header.totalDiscount": "Total discount",
    "table.itemGroups.input.label.markup": "Markup",
    "table.itemGroups.input.label.discount": "Discount",
    "table.itemGroups.input.label.discount2": "Discount 2",
    "table.itemGroups.input.label.discount3": "Discount 3",
    "table.itemGroups.input.label.discount4": "Discount 4",
    "table.itemGroups.input.label.markupPercentage": "Cost Markup (%)",
    "table.itemGroups.input.label.discountPercentage": "Discount (%)",
    "table.itemGroups.input.label.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.input.label.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.input.label.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.input.label.serviceDiscountPercentage": "Discount 2 (%)",
    "table.itemGroups.input.label.bonusDiscountPercentage": "Discount 3 (%)",
    "table.itemGroups.input.label.projectDiscountPercentage": "Discount 4 (%)",
    "table.itemGroups.header.discountPercentage": "Discount (%)",
    "table.itemGroups.header.discount2Percentage": "Discount 2 (%)",
    "table.itemGroups.header.discount3Percentage": "Discount 3 (%)",
    "table.itemGroups.header.discount4Percentage": "Discount 4 (%)",
    "table.itemGroups.header.totalDiscountPercentage": "Total discount (%)",
    "table.itemGroups.header.totalNet": "Total Net",
    "table.itemGroups.header.margin": "Gross Margin",
    "table.itemGroups.header.cost": "Cost",
    "table.itemGroups.header.actions": "Actions",
    "table.itemGroups.header.totalCost": "Total cost",
    "table.itemGroups.header.listPrice": "List price",
    "table.itemGroupsOptional.title": "Optional",
    "categories.sharedProducts": "Shared products",
    "categories.customProducts": "Custom products",
    "catalog.productTable.buttons.addProductToLineItem": "Add to Line Item",
    "catalog.productTable.buttons.addAllProductsToLineItem":
      "Add all to Line Item",
    "catalog.productTable.buttons.addProductsToQuote": "Add to Quote",
    "catalog.productTable.buttons.addAllProductsToQuote": "Add all to Quote",
    "quote.buttons.exportToExcel": "Export",
    "catalog.selectACategoryFirst": "Select a category first",
    "button.import": "Import",
    "dialog.importExcel.title": "Import Excel",
    "dialog.createQuote.title": "Create quote",
    "dialog.createQuote.subtitle": "Create a new quote",
    "dialog.createQuote.input.label.name": "Name",
    "dialog.createQuote.input.label.description": "Description",
    "dialog.createQuote.input.label.region": "Region",
    "dialog.createQuote.input.label.customer": "Customer",
    "dialog.updateQuote.title": "Edit quote",
    "dialog.updateQuote.subtitle": "Adjust an existing quote",
    "button.uploadGeneric.placeholder": "Upload file",
    "checkbox.import.label.override": "Check here to override existing entries",
    priceListSelectLabel: "Price list",
    currencySelectLabel: "Currency",
    "button.goBackToOpportunities": "Back to opportunities",
    "button.goBackToOpportunity": "Back to opportunity",
    "button.goBackToQuote": "Back to quote",
    "item.property.label.note": "Customer position / asset position",
    "item.property.label.listPrice": "List price",
    "item.property.label.totalList": "Total list price",
    "item.property.label.discount": "Discount",
    "item.property.label.totalDiscount": "Total discount",
    "item.property.label.totalCost": "Total cost",
    "item.property.label.totalNet": "Total net price",
    "item.property.label.status": "Status",
    "item.property.label.name": "Name",
    "item.property.label.partId": "Article number",
    "item.property.label.description": "Description",
    "item.property.label.quantity": "Quantity",
    "subItem.property.label.totalList": "List",
    "subItem.property.label.totalCost": "Cost",
    "subItem.property.label.totalNet": "Net",
    "lineItems.bom.label": "Bill of materials",
    "priceSummary.totalCost": "Total cost",
    "priceSummary.totalList": "Total list",
    "priceSummary.totalNet": "Total net",
    "dialog.requestQuote.title": "Send request",
    "select.topBottom.option.label.top": "List",
    "select.topBottom.option.label.bottom": "Cost+",
    "priceList.select.confirm.title": "Do you want to proceed?",
    "priceList.select.confirm.subtitle":
      "Changing the price list at this level will overwrite all price lists at lower levels.",
    "toast.error.unknown": "An error occurred",
    "toast.success.itemWasAddedToQuote": "Item was added to quote",
    "toast.success.groupCreated": "The group was created",
    "toast.success.groupWithItemsCreated":
      "The group was created and Items were added",
    "toast.success.itemWasAddedToCart": "Item was added to the cart",
    "form.field.label.customerNumber": "Customer Number",
    "form.field.label.companyName": "Company Name",
    "form.field.label.company": "Company",
    "form.field.label.name": "Name",
    "form.field.label.contactSalutation": "Salutation",
    "form.field.label.contactTitle": "Title",
    "form.field.label.contactFirstName": "Name",
    "form.field.label.contactLastName": "Last Name",
    "form.field.label.street": "Street",
    "form.field.label.streetNumber": "Number",
    "form.field.label.postalCode": "Postal Code",
    "form.field.label.town": "Town",
    "form.field.label.country": "Country",
    "form.field.label.emailAddress": "Email",
    "form.field.label.phoneNumber": "Phone",
    "form.field.label.mobileNumber": "Mobile",
    "form.field.label.companyId": "Company",
    "form.field.label.description": "Description",
    "form.field.error.email": "Email address is not valid",
    "quoteInfo.buttons.addNewCustomer": "Add new customer",
    "quoteInfo.buttons.addNewCompany": "Add new company",
    "quoteInfo.buttons.addNewSalesLocation": "Add new sales",
    "quoteInfo.buttons.assignSalesLocation": "Assign",
    "quoteInfo.buttons.assignCustomer": "Assign customer",
    "quoteInfo.buttons.save": "Assign customer",
    "quoteInfo.general.header": "General information",
    "quoteInfo.general.quoteId": "Quote id",
    "quoteInfo.general.quote.uniqueNumberString": "Quote number",
    "quoteInfo.general.opportunity.uniqueNumberString": "Opportunity number",
    "quoteInfo.general.currency": "Currency",
    "quoteInfo.general.createdByName": "Created by",
    "quoteInfo.general.quoteCreationDate": "Quote creation date",
    "quoteInfo.general.lastUpdatedByName": "Last updated by",
    "quoteInfo.general.lastUpdatedOn": "Last updated on",
    "quoteInfo.salesLocation.header": "Sales",
    "quoteInfo.customer.header": "Customer",
    "quoteInfo.customer.customerNumber": "Customer number",
    "quoteInfo.customer.companyName": "Company name",
    "quoteInfo.customer.contactSalutation": "Salutation",
    "quoteInfo.customer.contactFirstName": "First name",
    "quoteInfo.customer.contactLastName": "Last name",
    "quoteInfo.customer.contactTitle": "Title",
    "quoteInfo.customer.street": "Street",
    "quoteInfo.customer.streetNumber": "Street number",
    "quoteInfo.customer.postalCode": "Postal code",
    "quoteInfo.customer.town": "Town",
    "quoteInfo.customer.country": "Country",
    "quoteInfo.customer.emailAddress": "Email",
    "quoteInfo.customer.phoneNumber": "Phone number",
    "quoteInfo.customer.mobileNumber": "Mobile number",
    "dialog.createSalesLocation.title": "Create sales location",
    "dialog.createSalesLocation.subtitle": "Create a new sales location",
    "quoteInfo.customer.salesLocations.header": "Sales",
    "quoteInfo.customer.salesLocations.salesLocationName":
      "Sales locations name",
    "quoteInfo.customer.salesLocations.contactTitle": "Title",
    "quoteInfo.customer.salesLocations.contactSalutation": "Salutation",
    "quoteInfo.customer.salesLocations.contactFirstName": "First name",
    "quoteInfo.customer.salesLocations.contactLastName": "Last name",
    "quoteInfo.customer.salesLocations.street": "Street",
    "quoteInfo.customer.salesLocations.streetNumber": "Street number",
    "quoteInfo.customer.salesLocations.postalCode": "Postal code",
    "quoteInfo.customer.salesLocations.town": "Town",
    "quoteInfo.customer.salesLocations.country": "Country",
    "quoteInfo.customer.salesLocations.emailAddress": "Email",
    "quoteInfo.customer.salesLocations.phoneNumber": "Phone number",
    "quoteInfo.customer.salesLocations.mobileNumber": "Mobile number",
    "dialog.addCustomProduct.priceCost.value": "Value",
    "dialog.addCustomProduct.priceCost.validFrom": "Valid from",
    "dialog.addCustomProduct.priceCost.validTo": "Valid to",
    "dialog.addCustomProduct.price": "Price",
    "dialog.addCustomProduct.cost": "Cost",
    "productDetails.partId": "Article number",
    "productDetails.listPrice": "List price",
    "productDetails.cost": "Cost",
    "searchField.label": "Search",
    "SERVER_ERROR.DISCOUNT_EXCEEDS_LIMIT": "Discount exceeds limit",
    "SERVER_ERROR.PRODUCT_IS_IN_USE": "Product is in use and cannot be deleted",
    "filter.filterAttributeInput.label": "Attribute",
    "filter.filterOperatorInput.label": "Operator",
    "filter.filterValueInput.label": "Value",
    "filter.button.applyFilter": "Apply",
    "filter.button.clearAllFilter": "Clear all",
    "toast.error.filterAlreadyPresent": "Filter already present",
    "selectionBanner.text": "{{selectedProducts}} products selected",
    "selectionBanner.clearSelection.text": "clear selection",
    "cart.label.emptyCart": "Your cart is empty",
    "cart.button.addConfiguration": "Add configuration",
    "cart.button.addArticle": "Add article",
    "cart.button.saveShoppingCart": "Save shopping cart",
    "cart.button.printShoppingCart": "Print shopping cart",
    "cart.button.import": "Import",
    "cart.button.export": "Export",
    "cart.summary.subtotal.label": "Subtotal",
    "cart.summary.totalNet.label": "Total net",
    "cart.summary.button.requestQuote": "Request Quote",
    "cart.summary.button.proceedToCheckout": "Proceed to Checkout",
    "quotes.table.uniqueNumberString": "Number",
    "quotes.table.name": "Name",
    "quotes.table.lastUpdatedOn": "Last updated",
    "quotes.table.creationDate": "Creation date",
    "quotes.table.status": "Status",
    "quotes.table.toolbar.search": "Search",
    "infotext.userNotLoggedIn": "Not logged in",
    "buttons.save": "Salvar",
    "buttons.reset": "Reanudar",
    "quotes.table.toolbar.filters.status": "Status",
    "iconButton.download": "Descargar",
    "iconButton.clone": "Clon",
    "iconButton.delete": "Borrar",
    "drawer.showBOM.title": "Bill of materials",
    "drawer.showSummary.title": "Resumen",
    "workflowSelect.title": "Please choose a Workflow",
    "workflowSelect.customer.title": "Customer",
    "workflowSelect.customer.subTitle":
      "A streamlined workflow for browsing and purchasing products.",
    "workflowSelect.sales.title": "Sales",
    "workflowSelect.sales.subTitle":
      "Configure, price and quote with an integrated catalog, tailored for sales persons.",
    "workflowSelect.projectList.title": "Project List",
    "workflowSelect.projectList.subTitle":
      "Manage articles and projects efficiently with a comprehensive list view.",
    "moveRowMenu.options.topPosition": "Top postion",
    "opportunities.quotesTable.header.name": "Name",
    "opportunities.quotesTable.header.description": "Description",
    "opportunities.quotesTable.header.customer": "Customer",
    "opportunities.quotesTable.header.quoteNumber": "Quote number",
    "opportunities.quotesTable.header.createdByName": "Created by",
    "opportunities.quotesTable.header.lastUpdatedByName": "Last updated by",
    "opportunities.quotesTable.header.lastUpdatedOn": "Last updated on",
    "opportunities.quotesTable.header.status": "Status",
    "outputOptionsSelection.checkbox.includeLongText.label":
      "Includes Long Text",
    "outputOptionsSelection.checkbox.includePartId.label":
      "Includes Part Number of Articles",
    "outputOptionsSelection.checkbox.includePrices.label": "Includes Prices",
    "outputOptionsSelection.checkbox.includeDiscounts.label":
      "Includes Discounts",
  },
  translation: { DATA_SHEET: "Hoja de datos" },
  WEG: {
    "appcalc.recommendation.flag": "Recomendación WEG",
    "btn.askForQuote": "Solicitar cotización",
    "btn.import": "importar",
    "btn.importConfigId": "Importar ID GPS",
    "btn.loginToEasy": "Volver al EASY",
    "btn.sendRequest": "Enviar solicitud",
    "btn.setAdministrationArea": "Acceder",
    "button.send": "Enviar",
    "button.back": "Volver",
    "button.upload": "Cargar",
    "buttons.addToQuote": "Añadir a la lista de ítems",
    "buttons.backToCart": "Ir a la lista de proyectos",
    "buttons.backToRoot": "Ir a la página principal",
    "buttons.cancel": "Cancelar",
    "buttons.confirm": "Confirmar",
    "buttons.download": "Descargar",
    "buttons.ExitConfigurationButton": "Lista de proyectos",
    "buttons.ExitWithoutSavingButton": "Salir",
    "buttons.header.returnToWEG": "Página principal",
    "buttons.header.returnToWEG.url":
      "https://www.weg.net/catalog/weg/CL/es/Reductores-e-Motorreductores/Motorreductores/c/GLOBAL_GEARBOXES_GEAREDMOTORS",
    "buttons.header.toProjectList": "Reiniciar configuración",
    "buttons.resetConfiguration": "Restablecer",
    "buttons.SaveAndExitConfigurationButton": "Guardar y salir",
    "buttons.saveAsTemplate": "Guardar modelo",
    "buttons.SaveConfigurationButton": "Guardar configuración",
    "buttons.AddToProjectList": "Guardar en la lista de proyectos",
    "buttons.select": "Seleccionar",
    "buttons.showAllProjects": "Mostrar todos los proyectos",
    "cart.table.header.configurationId": "ID GPS",
    "cart.table.header.customerId": "ID del cliente",
    "cart.table.header.item": "Ítem",
    "cart.table.header.notes": "Notas",
    "cart.table.header.quantity": "Cantidad",
    "cart.table.header.syncSelect": "Sincronizar",
    "cart.table.header.type": "Tipo",
    "cart.table.header.priceIndicator": "Indicador de precio",
    "cart.table.header.status": "Estado",
    "cartViewHeader.button.title": "Nueva configuración",
    "config.btn.searchProduct": "Buscar producto",
    "description.configurator.appCalc":
      "Dimensione el producto con los datos de su equipo",
    "description.configurator.productConfigurator":
      "Dimensione el producto con datos de accionamiento",
    "dialog.addToQuote.title": "Por favor, seleccione un ítem",
    "dialog.administrationArea.header": "Ubicación",
    "error.invalidGUID": "ID GPS inválido",
    "error.noPOSfound":
      "Error en la búsqueda de contacto. Contacte al administrador",
    "header.cart.title": "Lista de proyectos",
    "label.configId": "ID de configuración",
    "label.country": "País",
    "label.form.city": "Ciudad",
    "label.form.company": "Empresa",
    "label.form.companyName": "Nombre de la empresa",
    "label.form.country": "País",
    "label.form.email": "E-mail",
    "label.form.formCity": "Ciudad",
    "label.form.formDistrict": "Barrio",
    "label.form.formPurchasePlace": "Lugar de compra",
    "label.form.formRegion": "Región",
    "label.form.formUserComment": "Comentario",
    "label.form.name": "Nombre",
    "label.form.phone": "Teléfono",
    "label.form.phoneNumber": "Teléfono",
    "label.form.street": "Calle",
    "label.form.streetNr": "Nº",
    "label.form.surname": "Apellido",
    "label.form.userInquiry": "¿Cuál es su solicitud?",
    "label.form.zipCode": "Código postal",
    "latestProjects.table.header.batch": "Comisión",
    "latestProjects.table.header.lastChange": "Última modificación",
    "latestProjects.table.header.orderNumber": "Número de pedido",
    "latestProjects.table.header.projectName": "Nombre del proyecto",
    "latestProjects.table.header.projectNumber": "Número del proyecto",
    "latestProjects.table.title": "Proyectos más recientes",
    "message.confirmSendQuoteRequest":
      "Enviar esta solicitud finalizará el proceso y eliminará los ítems de la lista de proyectos.",
    "message.errorSendQuoteRequest":
      "Lamentablemente no fue posible completar la solicitud. Por favor, intente nuevamente.",
    "message.successSendQuoteRequest":
      "Hemos enviado su solicitud a nuestro equipo de ventas y responderemos lo antes posible.",
    "modal.ExitConfiguration.note":
      "Los cambios no guardados se perderán. ¿Continuar?",
    "modal.ExitConfiguration.title": "Ir a la lista de proyectos",
    "preselector.page1.linkText": "Contáctenos",
    "preselector.subcaption.text": "Encuentre su producto según su necesidad.",
    "products.buttons.addToQuote": "Añadir a la lista de ítems",
    "products.buttons.configure": "Configurar",
    "title.configurator.appCalc": "Cálculo de aplicación",
    "title.configurator.preselection": "Gear ProSelect",
    "title.configurator.productConfigurator": "Configurador de producto",
    "title.confirmSendQuoteRequest": "Solicitar cotización",
    "title.successSendQuoteRequest": "¡Gracias por su solicitud!",
    "toast.JmpToEasy.timeout":
      "Tiempo límite de conexión con Easy agotado. Intente nuevamente.",
    "tooltip.copyToClipboard": "Copiar",
    "subconfigurationNavigation.previousItem": "Volver",
    "subconfigurationNavigation.nextItem": "Siguiente",
    "buttons.edit": "Editar",
    "response.WegStoreFinderError":
      "Código de estado de la API de Easy {{params}}",
    "response.Unauthorized": "ID de sesión no encontrado.",
    "response.NoQuoteFound":
      "No se encontró cotización para esta sesión: {{params}}",
    "response.SomethingWentWrong": "Algo salió mal: {{params}}",
    "response.NoDownloadManual": "No se encontró manual de producto.",
    "response.WrongInputParameters":
      "Los siguientes parámetros de entrada son necesarios: {{params}}",
    noQuoteFound: "No se encontró cotización para esta sesión: {{params}}",
    noConfigurationsFound: "Ninguna configuración seleccionada",
    noBaseConfigurableFound: "No se encontró configuración base",
    noFromToCharacteristics:
      "No se encontraron características para los ítems seleccionados",
    "buttons.downloadUserManual": "Manual del producto",
    footerCopyright: "WEG | Gear ProSelect",
    ProjectListEmptyMsg: "no hay proyectos",
    "error.projectList.noItems": "no hay proyectos",
    "error.projectList.incompleteItems":
      "Algunos proyectos aún están incompletos",
  },
};
